import React from 'react';
import OrangeTick from '../../assets/orangeTick.svg';

function RadioButtonWithOrangeTick({title, checked, onChange}) {
    return (
        <div className={'radioButtonContainer'} onClick={onChange}>
            <button>
                {checked ? <img src={OrangeTick} alt={'checking'}/> : null}
            </button>
            <p>
                {title}
            </p>
        </div>
    )
}

export default RadioButtonWithOrangeTick;